import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TextField, LinearProgress } from '@material-ui/core';

import { useTitleStyles } from './FeatureComponent';
import { TableDataContext } from '../../tabeditor/tools/Table';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
  timeEditor: {
    width: '11rem',
    '& > .MuiInputBase-root': {
      height: '44px'
    }
  },
  timeEditorInTable: {
    maxWidth: '25rem',
    width: '10rem',
    '& > .MuiInputBase-root': {
      height: '44px'
    }
  }
}));

export const getTimePayloadData = (value) => ({
  timeValue: value
});

export const Time = ({
  featureInfo,
  time,
  setValueState,
  saveChangedValue,
  loading,
  error
}) => {
  const { t } = useTranslation();
  const [isInTableContext] = useContext(TableDataContext);
  const classesTitle = useTitleStyles();

  const classes = useStyles();

  const title = isInTableContext ? null : featureInfo.title;
  const mandatory = featureInfo.mandatory;

  const hasDefaultData = featureInfo.hasDefaultData;

  let timeString;
  if (time && time.hour != null && time.minute != null) {
    timeString =
      String(time.hour).padStart(2, '0') +
      ':' +
      String(time.minute).padStart(2, '0');
  } else {
    timeString = '';
  }

  const [blurState, setBlurState] = useState(timeString);

  const isMandatoryError = mandatory && timeString == '';
  error = error || '';
  let helper = '';
  if (loading) {
    helper = <LinearProgress color="secondary" />;
  } else if (isMandatoryError && !hasDefaultData) {
    helper = t('common.errorMandatory');
  }

  function saveValue(newTimeString) {
    if (newTimeString === undefined || blurState == newTimeString || loading) {
      return;
    }

    setBlurState(newTimeString);

    let newValue = null;

    if (newTimeString) {
      newValue = getTimeValueObject(newTimeString);
    } else if (mandatory && !hasDefaultData) {
      return;
    }

    setValueState(newValue);
    saveChangedValue(newValue, getTimePayloadData(newValue));
  }

  function getTimeValueObject(newTimeString) {
    const timeSplitted = newTimeString.split(':');
    return {
      hour: timeSplitted[0],
      minute: timeSplitted[1]
    };
  }

  function showError() {
    if (!error) return;
    TOGO.Util.notifyResponse(error, true);
  }

  return (
    <TextField
      label={title}
      InputLabelProps={{
        shrink: false,
        disableAnimation: true,
        className: classesTitle.title
      }}
      className={
        isInTableContext ? classes.timeEditorInTable : classes.timeEditor
      }
      variant={isInTableContext ? 'standard' : 'outlined'}
      value={timeString}
      type="time"
      error={Boolean(error) || (isMandatoryError && !hasDefaultData)}
      FormHelperTextProps={{ component: 'div' }}
      helperText={helper}
      onMouseEnter={showError}
      onChange={(event) => saveValue(event.target.value)}
    />
  );
};
